<div class="flex justify-between items-center gap-2">
  <h1 class="text-2xl font-bold truncate">{{ text() }}</h1>
  @if (image()) {
    <img
      [src]="image()"
      alt="header"
      [ngClass]="imageClass()"
      draggable="false" />
  }
</div>
